import "../styles/legal.css";

const legalPages = {
  "terms-and-conditions": {
    title: "Terms & Conditions",
    subtitle: "The 3D Creator - Custom Gifting & 3D Printing",
    dateLabel: "Last Updated",
    date: "April 2025",
    intro:
      "Please read these Terms & Conditions carefully before placing an order with The 3D Creator. By placing an order, you confirm that you have read, understood, and agreed to these terms in full.",
    sections: [
      {
        heading: "1. General",
        body: [
          "The 3D Creator specialises in custom 3D-printed products and personalised gifts. All items are made-to-order and customised specifically for each customer. As a result, our policies differ from those of standard retail stores.",
        ],
      },
      {
        heading: "2. Orders & Customisation",
        body: [
          "2.1 All orders are custom-made based on the design details, colours, and specifications provided by the customer at the time of ordering.",
          "2.2 It is the customer's responsibility to ensure all order details - including names, text, dimensions, and design references - are accurate before confirming an order.",
          "2.3 Once an order is confirmed and production has begun, changes may not be possible. Please contact us as soon as possible if you need to modify your order.",
          "2.4 The 3D Creator reserves the right to refuse any order that violates copyright, contains offensive content, or cannot be produced for technical reasons.",
        ],
      },
      {
        heading: "3. Pricing & Payment",
        body: [
          "3.1 All prices are listed at the time of order confirmation. Prices may vary based on complexity, materials, and order quantity.",
          "3.2 Full payment is required before production begins, unless a written prior arrangement has been made.",
          "3.3 The 3D Creator reserves the right to update pricing at any time without prior notice.",
        ],
      },
      {
        heading: "4. No Return Policy",
        body: [
          "All sales are final. We do not accept returns or issue refunds on any custom-made or personalised products.",
          "4.1 Because every product is made-to-order and personalised for you, we are unable to resell returned items. We therefore strictly do not accept returns under any circumstances, including change of mind, incorrect details provided by the customer, personal preference or aesthetic dissatisfaction, and delays in delivery beyond our control.",
          "4.2 We strongly recommend reviewing all order details before placing your order. Our team is happy to assist with design previews before production begins.",
        ],
      },
      {
        heading: "5. Replacement Policy (Damaged in Transit)",
        body: [
          "While we take great care in packaging your order, damage can occasionally occur during shipping. We offer a one-time replacement under strict conditions.",
          "5.1 Eligibility Criteria: the item must have been damaged during delivery, not as a result of misuse, mishandling, or damage after delivery. You must submit an unboxing video that clearly shows the sealed package being opened for the first time, capturing the condition of the packaging and the item inside from start to finish. Clear photographs of the damaged item and the packaging, including outer box, inner wrapping, and any visible damage, must be provided. The claim must be raised within 48 hours of delivery as confirmed by the courier's tracking timestamp.",
          "5.2 Unboxing Video Requirements: the unboxing video is mandatory and non-negotiable. Claims submitted without a valid unboxing video will not be processed under any circumstances. The video must be recorded in one continuous, unedited take with no cuts or breaks, clearly show the outer packaging including courier labels and seals before opening, capture the full unboxing process from unsealing the package to revealing the item inside, clearly show the damage to the item, and be of sufficient quality and clarity for damage to be visible. Videos that are edited, paused, spliced, or otherwise altered will not be accepted.",
          "5.3 How to Raise a Replacement Claim: contact us within 48 hours of delivery with your order number, unboxing video, clear photographs of the damaged item and packaging, and a brief description of the damage. Our team will review your claim within 3-5 business days. If approved, we will begin producing a replacement at no additional charge.",
          "5.4 Replacement Terms: replacements are provided only once per order. We do not offer cash refunds in lieu of a replacement. Replacement items will be produced and dispatched within the standard production timeline. The replacement will be identical to the original order unless otherwise agreed in writing.",
        ],
      },
      {
        heading: "6. Shipping & Delivery",
        body: [
          "6.1 Estimated delivery timelines are provided at the time of order and are subject to change based on production schedules and courier availability.",
          "6.2 Once an order is dispatched, The 3D Creator is not responsible for delays caused by the courier, customs, or circumstances beyond our control.",
          "6.3 It is the customer's responsibility to provide a correct and complete delivery address. We are not liable for non-delivery due to incorrect address details.",
          "6.4 Risk of loss passes to the customer upon handover to the courier.",
        ],
      },
      {
        heading: "7. Intellectual Property",
        body: [
          "7.1 All original designs created by The 3D Creator remain the intellectual property of The 3D Creator.",
          "7.2 Customers who provide their own designs confirm that they have the legal right to use those designs and indemnify The 3D Creator against any third-party intellectual property claims.",
        ],
      },
      {
        heading: "8. Limitation of Liability",
        body: [
          "8.1 The 3D Creator's liability is limited to the replacement of the specific item as outlined in Section 5 above.",
          "8.2 We are not liable for any indirect, incidental, or consequential damages, including but not limited to loss of profit, loss of occasion, or emotional distress.",
        ],
      },
      {
        heading: "9. Privacy",
        body: [
          "9.1 Customer information collected during the order process is used solely for the purpose of fulfilling your order and communicating with you about it.",
          "9.2 We do not share your personal information with third parties, except as necessary for courier and payment processing services.",
        ],
      },
      {
        heading: "10. Changes to These Terms",
        body: [
          "The 3D Creator reserves the right to update or modify these Terms & Conditions at any time. The latest version will always be available on our website or upon request. Continued use of our services after changes constitutes acceptance of the updated terms.",
        ],
      },
      {
        heading: "11. Contact Us",
        body: [
          "For any queries regarding these Terms & Conditions, replacement claims, or your order, please reach out to us.",
          "Business Name: The 3D Creator",
          "Email: the3dcreator.co@gmail.com",
          "Phone/WhatsApp: 6261616661",
          "Instagram: https://www.instagram.com/the3dcreator.co/",
          "By placing an order with The 3D Creator, you acknowledge that you have read and agree to these Terms & Conditions.",
          "Copyright 2025 The 3D Creator. All Rights Reserved.",
        ],
      },
    ],
  },
  "return-policy": {
    title: "Return & Refund Policy",
    subtitle: "The 3D Creator - Custom Gifting & 3D Printing",
    dateLabel: "Effective Date",
    date: "May 2026",
    sections: [
      {
        heading: "1. Our Custom Products Policy",
        body: [
          "At The 3D Creator, every product is custom-made to order - designed, printed, and crafted specifically for you. Because of this, we do not accept returns or offer refunds once an order has been placed and production has begun.",
          "We put immense care into every piece. Please review your order details carefully before confirming your purchase.",
        ],
      },
      {
        heading: "2. No Returns",
        body: [
          "Due to the custom and personalised nature of our products, we strictly do not accept returns for the following reasons: the product was made to your specific design or personalisation, change of mind or incorrect size/colour selected at the time of order, the product has been used, handled, or modified after delivery, or delays caused by incorrect or incomplete delivery information provided by the customer.",
          "We encourage all customers to double-check spelling, colours, dimensions, and designs before placing an order. Our team is happy to assist you before purchase.",
        ],
      },
      {
        heading: "3. Replacement Policy - Damaged in Delivery",
        body: [
          "We do offer a free replacement if your item arrives damaged or broken due to a delivery/transit issue. However, to qualify for a replacement, the conditions below must be strictly met.",
          "3.1 Required Evidence: you must provide both an unboxing video and clear photographs. The unboxing video must be continuous and unedited, recorded from the moment you begin opening the package, clearly showing the condition of the packaging and the item as it is revealed. Photographs must show the damaged item, the packaging inside and outside, and any visible damage.",
          "Replacement requests submitted without an unboxing video will not be accepted under any circumstances. This policy exists to ensure fairness and to protect both our customers and our business from fraudulent claims.",
          "3.2 How to Submit a Replacement Request: contact us within 48 hours of receiving your order via email or WhatsApp. Include your Order ID, the unboxing video, photos of the damage, and a clear description of the damage. Requests submitted after 48 hours of confirmed delivery will not be eligible for replacement.",
          "3.3 Replacement Process: once your replacement request is reviewed and approved, we will confirm your replacement within 2 business days. Your replacement item will be printed and dispatched within our standard production timeline. No additional charges will be applied for an approved replacement.",
        ],
      },
      {
        heading: "4. What Is Not Covered",
        body: [
          "The following situations are not eligible for replacement or refund: minor colour variations due to screen display differences, slight size or texture differences inherent to 3D printing processes, damage caused after delivery, items damaged due to improper use or exposure to heat, water, or force, missing or incomplete unboxing video, and requests made after 48 hours of delivery.",
        ],
      },
      {
        heading: "5. Order Cancellations",
        body: [
          "Cancellations may be accepted only if requested within 12 hours of placing the order, provided that production has not yet started. Once printing has begun, we are unable to cancel or modify the order.",
          "To request a cancellation, contact us immediately with your Order ID.",
        ],
      },
      {
        heading: "6. Contact Us",
        body: [
          "If you have any questions about this policy or need assistance with your order, please reach out to us.",
          "The 3D Creator",
          "Email: the3dcreator.co@gmail.com",
          "WhatsApp: +91 6261616661",
          "Website / Instagram: https://www.instagram.com/the3dcreator.co/",
          "We are committed to making every customer experience a great one. Thank you for supporting our small business.",
          "Copyright 2025 The 3D Creator. All rights reserved.",
        ],
      },
    ],
  },
  "privacy-policy": {
    title: "Privacy Policy",
    subtitle: "The 3D Creator - Custom Gifting & 3D Printing",
    dateLabel: "Effective Date",
    date: "23 April 2026",
    sections: [
      {
        heading: "1. Introduction",
        body: [
          "Welcome to The 3D Creator. We are a custom gifting and 3D printing business dedicated to crafting unique, personalized products for our valued customers. This Privacy Policy explains how we collect, use, store, and protect your personal information when you interact with us - whether through our website, social media, messaging platforms, or in person.",
          "By placing an order or using our services, you agree to the terms outlined in this Privacy Policy. Please read it carefully.",
        ],
      },
      {
        heading: "2. Information We Collect",
        body: [
          "When you interact with The 3D Creator, we may collect personal identification information, order-related information, and communication records.",
          "2.1 Personal Identification Information: full name, phone number and email address, delivery address and billing address, and social media handles or usernames if orders are placed via DMs.",
          "2.2 Order-Related Information: custom design files, images, or references provided by you, order specifications, preferences, and personalisation details, payment confirmation, and transaction references. We do not store full payment card details.",
          "2.3 Communication Records: messages, emails, or chats exchanged with us for order processing or support, plus unboxing videos and photographs submitted for replacement claims.",
        ],
      },
      {
        heading: "3. How We Use Your Information",
        body: [
          "We use the information we collect solely to process, fulfil, and deliver your custom orders, contact you regarding your order status, verify replacement eligibility in the event of delivery damage, improve our products and customer experience, maintain records for business and accounting purposes, respond to enquiries, and provide customer support.",
          "We do not use your personal data for unsolicited marketing without your explicit consent.",
        ],
      },
      {
        heading: "4. No Return Policy",
        body: [
          "As all products offered by The 3D Creator are custom-made and personalised to individual specifications, we do not accept returns under any circumstances. Each item is produced exclusively for you and cannot be resold or reused.",
          "We strongly encourage customers to review all order details, designs, dimensions, and specifications carefully before confirming their order. Once production has commenced, changes may not be possible.",
        ],
      },
      {
        heading: "5. Replacement Policy for Delivery Damage",
        body: [
          "We take great care in packaging our products. However, in the rare event that an item arrives damaged due to mishandling during transit, we offer a replacement subject to strict conditions.",
          "5.1 Eligibility Conditions: the damage must have occurred during delivery and must be visible on the product upon arrival. The customer must provide a clear, uninterrupted unboxing video showing the sealed package being opened, capturing the condition of the item from the moment it is unboxed. The customer must also provide clear photographs of the damaged item, packaging, and shipping label. The unboxing video and photographs must be submitted within 24 hours of delivery.",
          "5.2 How to Submit a Replacement Claim: send the unboxing video and photos to our official contact number or email, include your order ID, name, and a brief description of the damage. Our team will review the submission and respond within 3-5 business days.",
          "5.3 Important Disclaimers: replacement requests submitted without a valid unboxing video will not be considered. Damage caused by customer misuse, improper handling after delivery, or minor cosmetic variations within acceptable production tolerances are not eligible for replacement. Replacement is subject to the same design and specifications as the original order. No modifications or refunds will be offered in lieu of replacement.",
        ],
      },
      {
        heading: "6. Sharing of Your Information",
        body: [
          "We respect your privacy. The 3D Creator does not sell, rent, or trade your personal information to any third parties. We may share your information only with delivery and logistics partners to facilitate shipment, with payment processing platforms to complete your transaction securely, or when required by law, regulation, or legal process.",
          "All third-party partners we work with are expected to handle your data responsibly and only use it for the specified purpose.",
        ],
      },
      {
        heading: "7. Data Retention",
        body: [
          "We retain your personal information and order data for as long as is necessary to fulfil the purpose for which it was collected, or as required by applicable law. Unboxing videos and photographs submitted for replacement claims are retained only for the duration of the claim review process and deleted thereafter, unless required for dispute resolution.",
        ],
      },
      {
        heading: "8. Data Security",
        body: [
          "We take reasonable technical and organisational measures to protect your personal information from unauthorised access, misuse, loss, or disclosure. However, no method of transmission over the internet or electronic storage is completely secure, and we cannot guarantee absolute security.",
        ],
      },
      {
        heading: "9. Your Rights",
        body: [
          "You have the right to access the personal information we hold about you, request corrections to inaccurate or incomplete information, request deletion of your personal data subject to legal obligations, and withdraw consent for any optional communications at any time.",
          "To exercise any of these rights, please contact us using the details provided below.",
        ],
      },
      {
        heading: "10. Changes to This Privacy Policy",
        body: [
          "The 3D Creator reserves the right to update or modify this Privacy Policy at any time. Any changes will be effective immediately upon being posted or communicated to customers. We encourage you to review this policy periodically to stay informed about how we protect your information.",
        ],
      },
      {
        heading: "11. Contact Us",
        body: [
          "If you have any questions, concerns, or requests related to this Privacy Policy or your personal data, please contact us.",
          "The 3D Creator",
          "Custom Gifting & 3D Printing",
          "Email: the3dcreator.co@gmail.com",
          "Phone/WhatsApp: +91 6261616661",
          "Location: Bhatapara, Chhattisgarh",
          "End of Privacy Policy.",
        ],
      },
    ],
  },
};

export default function LegalPage({ type }) {
  const page = legalPages[type] || legalPages["terms-and-conditions"];

  return (
    <div className="legal-page">
      <section className="legal-hero">
        <p className="legal-kicker">The 3D Creator</p>
        <h1>{page.title}</h1>
        <p>{page.subtitle}</p>
        <span>
          {page.dateLabel}: {page.date}
        </span>
      </section>

      <article className="legal-card">
        {page.intro ? <p className="legal-intro">{page.intro}</p> : null}

        {page.sections.map((section) => (
          <section className="legal-section" key={section.heading}>
            <h2>{section.heading}</h2>
            {section.body.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </section>
        ))}
      </article>
    </div>
  );
}
